import { useEffect, useState } from "react";

export function resolvePhoneInputComponent(module) {
  const candidates = [
    module?.default,
    module?.PhoneInput,
    module,
  ];
  return candidates.find((candidate) => typeof candidate === "function") || null;
}

const FallbackPhoneInput = (props) => (
  <input
    type="tel"
    aria-label={props["aria-label"] || "Phone"}
    value={props.value || ""}
    onChange={(event) => {
      if (typeof props.onChange === "function") {
        props.onChange(event.target.value);
      }
    }}
    onFocus={props.onFocus}
    onBlur={props.onBlur}
    disabled={props.disabled}
    style={{
      width: "100%",
      border: "1px solid rgba(0, 0, 0, 0.37)",
      borderRadius: "10px",
      padding: "14px 16px",
      background: "transparent",
    }}
  />
);

const LazyPhoneInput = (props) => {
  const [Component, setComponent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    import("react-phone-input-2/lib/lib.js")
      .then((module) => {
        if (cancelled) {
          return;
        }
        const next = resolvePhoneInputComponent(module);
        setComponent(() => next || FallbackPhoneInput);
      })
      .catch(() => {
        if (!cancelled) {
          setComponent(() => FallbackPhoneInput);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!Component) {
    return <div className="phone-input-loading">Loading phone input...</div>;
  }
  return <Component {...props} />;
};

export default LazyPhoneInput;
